import React from "react";
import BottomNavWrapper from "components/shared/wrappers/BottomNavWrapper";
import {  useParams } from "bcms-react";
import PageContainer from "components/shared/containers/PageContainer";
/**
 * @function NoFooter
 * @returns {React.Component}
 * @exported true
 * @description Serves as a page component to allow us to route from MABI23 specific pages to ABI22 pages.
 */
export default function NoFooter(props) {
  const {page} = useParams();
  const setPage = page !== undefined ? page : props.page === undefined ? "accountSummary":props.page;
  return (
    <PageContainer>
      <BottomNavWrapper page = {setPage} hideNav={true}/>
    </PageContainer>
   
  );
}